export default __webpack_public_path__ + "static/media/outdoor-4.b1eb6d44.png";